var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.93085 3.09387C6.77035 2.73274 6.41222 2.5 6.01703 2.5H3.50024C2.94796 2.5 2.49813 2.949 2.51752 3.50094C2.83389 12.5058 7.49448 17.1664 16.4993 17.4827C17.0512 17.5021 17.5002 17.0523 17.5002 16.5V13.9832C17.5002 13.588 17.2675 13.2299 16.9063 13.0694L14.3187 11.9193C13.9706 11.7646 13.5649 11.8211 13.2723 12.0649L11.721 13.3577C11.4321 13.5984 11.0311 13.6583 10.6888 13.5025C8.39768 12.4595 7.54074 11.6025 6.49775 9.31139C6.34194 8.96912 6.40183 8.5681 6.64257 8.2792L7.93532 6.72787C8.17914 6.43529 8.23559 6.0296 8.08091 5.68156L6.93085 3.09387Z",
    stroke: "#8790A1",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcv);
export default __webpack_public_path__ + "static/media/call_icv.9bc66f0afefdd543b6c88b694994be6e.svg";
export { ForwardRef as ReactComponent };